export function isPromise(value: unknown): value is Promise<void> {
  return value && typeof value === 'object' && 'then' in value && typeof (value as { then: unknown }).then === 'function';
}
